import React from 'react';
import { IconInfoCircle } from '../icons';

const EmptyState = ({ icon, title, description, action }) => (
  <div className="min-h-[400px] flex flex-col items-center justify-center gap-6">
    <div className="flex flex-col items-center gap-2 max-w-[260px] text-center">
      {icon || <IconInfoCircle size={32} className="text-ink" />}
      <div>
        <p className="text-[15px] leading-[18px] font-medium text-ink">{title}</p>
        {description && (
          <p className="text-xs leading-[15px] text-ink-muted mt-1">{description}</p>
        )}
      </div>
    </div>
    {action}
  </div>
);

export default EmptyState;
